import React from 'react';
import {FormattedHTMLMessage, FormattedMessage, injectIntl} from 'react-intl';
import {Route} from 'react-router-dom';
import PropTypes from 'prop-types';
import {FormattedNavLink} from '@foes/react-i18n-routing';

import {HOME} from './../../../routing/routes';
import Helmet from './../../seo/Helmet';
import {ERROR_CODE_NOT_FOUND} from './../../../store/Error/ErrorReducer';

import Typography, {VARIANT} from './../../atoms/Typography/Typography';
import InlineButton from './../../atoms/InlineButton/InlineButton';

import Main from './../../layouts/Main/Main';
import Row from './../../layouts/Row/Row';
import Column from './../../layouts/Column/Column';

import './NotFound.css';

const NotFound = ({error, intl}) => (
  <Route
    render={({staticContext}) => {
      if (staticContext) {
        staticContext.status = error.status;
      }

      const is404 = error.status.toString() === '404';

      return (
        <Main className="not-found">
          <Helmet title={intl.formatMessage({id: `page.error.${is404 ? '404' : '500'}_title`})} />

          <Row className="not-found__title" scrollAnimation={false}>
            <Column>
              <Typography tag="h1" variant={VARIANT.H1}>
                <FormattedHTMLMessage id={`page.error.${is404 ? '404' : '500'}`} />
              </Typography>
            </Column>
          </Row>

          <Row scrollAnimation={false}>
            <Column>
              <FormattedNavLink name={HOME}>
                <Typography variant={VARIANT.BIG_BODY}>
                  <InlineButton>
                    <FormattedMessage id={'page.error.return_homepage'} />
                  </InlineButton>
                </Typography>
              </FormattedNavLink>
            </Column>
          </Row>
        </Main>
      );
    }}
  />
);

NotFound.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    status: PropTypes.number.isRequired,
  }).isRequired,
};

NotFound.defaultProps = {
  error: ERROR_CODE_NOT_FOUND,
};

export default injectIntl(NotFound);
